import React, { useContext } from 'react';

import ClientContext from 'app/src/contexts/ClientContext';
import DataState from 'app/src/elements/DataState';

import { Text } from 'app/src/styles';

const AuthButton = ({ onCompleted }) => {
  const { currentUser } = useContext(ClientContext);

  if (!currentUser) return <DataState.Loading />;

  return (
    <a href={currentUser.quickbooksAuthorizeUrl}>
      <Text style={{ fontWeight: 600 }}>
        Click here to authorize access to Quickbooks.
      </Text>
    </a>
  );
};

export default AuthButton;
